const Albums = [
  {
    title: 'Caligo',
    type: 'EP',
    year: 2025,
    image: '/Images/Caligo.jpg',
    tracks: ['Hatch', 'Unfurl', 'Dance of the Moth', 'Disperse'],
    links: {
      spotify: 'https://spotify.com/...',
      apple: 'https://music.apple.com/...',
      deezer: 'https://deezer.com/...',
      amazon: 'https://amazon.com/...',
      bandcamp: 'https://bandcamp.com/...',
      platoon: 'https://Platoon.lnk.to/caligo-piotr-opala',
    },
  },
  {
    title: 'Somnium',
    type: 'EP',
    year: 2024,
    image: '/Images/Somnium-EP.jpg',
    tracks: ['Inceptio', 'Finding Hope', 'Somnium', 'Waking Life'],
    links: {
      spotify: 'https://spotify.com/...',
      apple: 'https://music.apple.com/...',
      deezer: 'https://deezer.com/...',
      amazon: 'https://amazon.com/...',
      bandcamp: 'https://bandcamp.com/...',
      platoon: 'https://platoon.lnk.to/somnium-piotr-opala',
    },
  },
]

export default Albums
